export const imports = {
  form: {
    clickOrDrag: 'Click or drag file to this area to upload',
  },
  pageHeader: {
    title: 'CSV Import',
  },
}
